/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = exports.Operator = exports.Operation = exports.ConditionsType = void 0;
var ConditionsType;
(function (ConditionsType) {
    ConditionsType["NO_CONDITIONS"] = "NO_CONDITIONS";
    ConditionsType["CONDITION"] = "CONDITION";
    ConditionsType["CONDITION_TREE"] = "CONDITION_TREE";
})(ConditionsType = exports.ConditionsType || (exports.ConditionsType = {}));
var Operation;
(function (Operation) {
    Operation["EQ"] = "EQ";
    Operation["LT"] = "LT";
    Operation["LE"] = "LE";
    Operation["GT"] = "GT";
    Operation["GE"] = "GE";
})(Operation = exports.Operation || (exports.Operation = {}));
var Operator;
(function (Operator) {
    Operator["AND"] = "AND";
    Operator["OR"] = "OR";
})(Operator = exports.Operator || (exports.Operator = {}));
var Type;
(function (Type) {
    Type["UNSPECIFIED_FULFILLMENT_TYPE"] = "UNSPECIFIED_FULFILLMENT_TYPE";
    Type["PICKUP"] = "PICKUP";
    Type["DELIVERY"] = "DELIVERY";
    Type["DINE_IN"] = "DINE_IN";
    Type["CURBSIDE_PICKUP"] = "CURBSIDE_PICKUP";
})(Type = exports.Type || (exports.Type = {}));
//# sourceMappingURL=types.js.map